import fp from 'lodash/fp';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FiList } from "react-icons/fi";
import { compose, withStateHandlers } from 'recompose';
import { fullName } from '../../../../../services';
import { GeneralTable } from '../../../../components';

const UploadProgressModal = ({ showModal, toggleModal, details }) => {
  const columns = [
    {
      key: 'email',
      name: 'Email'
    },
    {
      key: 'user',
      name: 'User'
    },
    {
      key: 'total',
      name: 'Total'
    },
    {
      key: 'completed',
      name: 'Completed'
    },
    {
      key: 'failed',
      name: 'Failed'
    }
  ]
  const rows = fp.map(
    ({ email, user, progress }) => {
      return {
        email: {
          value: email
        },
        user: {
          value: user ? fullName(user.user) : 'Not Found'
        },
        total: {
          value: progress.total
        },
        completed: {
          value: progress.completed
        },
        failed: {
          value: progress.failed
        }
      }
    }
  )(details)
  return <span id='upload-progress-modal'>
    <Button bsStyle='plain' onClick={toggleModal}><FiList size={20} /></Button>
    <Modal show={showModal} onHide={toggleModal} dialogClassName='upload-progress-modal'>
      <Modal.Header>
        <Modal.Title componentClass='h2' className='text-center'>
          Upload Progress Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <GeneralTable className='kaplan-upload-progress-table' columns={columns} rows={rows} />
      </Modal.Body>
    </Modal>
  </span>
}

export default compose(
  withStateHandlers(
    {
      showModal: false
    },
    {
      toggleModal: ({ showModal }) => () => ({
        showModal: !showModal
      })
    }
  )
)(UploadProgressModal)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/cpd-point-portal/partial/upload-progress-modal.js